<template>
  <v-card>
    <v-card-title class="primary white--text">
      <v-icon>fas fa-list</v-icon>
      <h2 class="title ml-2">Pensamiento del día</h2>
    </v-card-title>
    <v-card-text v-if="value">
      <p class="subtitle-2 text-center mt-2">Fecha: {{value.fecha}}</p>
      <blockquote class="blockquote">{{value.pensamiento}}</blockquote>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" @click="$emit('close')">
        <v-icon left>fas fa-times</v-icon>
        Cerrar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'show-pensamiento',
  props: ['value']
}
</script>
